import Container from 'react-bootstrap/Container';

import charlotte1  from '../images/Charlotte15339.jpg';
import charlotte2  from '../images/Charlotte15254v1.jpg';

const WelcomeTab = () => {
    return (
        <Container className="py-4">
        <div className="padded-tab-container-class">
        <img src={charlotte1} alt="Charlotte Rose" style={{ paddingBottom: '16px', paddingLeft: '16px', width: '30vh', float: 'right' }} />
        <p>Born and raised in Salisbury, I specialise in acrylic paintings of landscapes and wildlife but I also use mixed media and chalk pastel, mainly focusing on our amazing local places in Hampshire, Dorset and Wiltshire. I am passionate about the natural environment, which I hope shines through in my work. I hope you enjoy having a look around - let me know if there's anything more you'd like to know about me or my work!</p>
        <h3>Artist statement</h3>

        <p>I have two passions in life: the natural world and art, and I'm lucky enough to be able to combine both. As well as a landscape painter, I am a practising ecologist, with my work taking me to many inspirational places in the UK.</p>

        <img src={charlotte2} alt="Charlotte Rose" style={{ paddingTop: '16px', paddingRight: '16px', width: '30vh', float: 'left' }} />

        <p>These passions started when I was very small, although it was in my teenage years that I discovered acrylic paints and soft pastels. My style tended towards impressionism and realism for many years, but recently I have focused on a more 'graphical' style. Colour and bold forms have always been in my work, with my compositions often immersing the viewer in the scene rather than being a distant landscape.</p>

        <p>I have exhibited for several years in Salisbury, and continue to do so despite having moved from there to Winchester in 2019. There is lots to inspire me in Wiltshire and Hampshire in particular, and I hope that my work highlights the pressures our natural world is under, as well as the beauty that can be found in surprising places.</p>

        <h3>Newsletter</h3>

        <p>Be the first to hear of the latest updates from the studio, including upcoming events and new work. Email <a href="mailto:charoftheshire@gmail.com">charoftheshire@gmail.com</a> to sign up to my quarterly newsletter.</p>

        <p>Your data will not be shared with anyone else. All data will be securely stored. You can unsubscribe at any time through emailing me.</p>

        <h3>Copyright</h3>

        <p>All images copyright Charlotte Rose - not available for reproduction without written permission of the artist.</p>
        </div>
      </Container>
    );
};

export default WelcomeTab;
